import MojitoCore from 'mojito/core';
import RoutingViewImpl from './routing-view.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * View which handles routing functionality with usage of react router Switch.
 *
 * @class RoutingView
 * @memberof Mojito.Applications.Sports
 */

export default UIView('RoutingView', RoutingViewImpl);
